import { EmailContactData } from '../../../../../models/EmailContact';
import CopyContactIdButton from '../CopyContactIdButton/CopyContactIdButton';
import { formatReceivedAt } from '../../../../../utils/emailContactHelpers';
import { Paperclip } from '@coolblue-development/icons';
import { Box, Typography } from '@coolblue-development/freddy';

interface EmailHeaderPreviewProps {
  data: EmailContactData;
}

const PREVIEW_MAX_LENGTH = 160;

const truncatePreview = (text: string): string =>
  text.length > PREVIEW_MAX_LENGTH ? `${text.slice(0, PREVIEW_MAX_LENGTH)}...` : text;

const EmailHeaderPreview = ({ data }: EmailHeaderPreviewProps): JSX.Element => {
  return (
    <Box data-testid="email-header-preview">
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
          {data.customerName && (
            <Typography variant="body" fontWeight={700} data-testid="email-customer-name">
              {data.customerName}
            </Typography>
          )}
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: '8px', alignItems: 'center' }}>
          {data.hasAttachments && <Paperclip color="#868A90" />}
          <CopyContactIdButton contactId={data.contactId} />
          {data.receivedAt && (
            <Typography variant="caption" data-testid="email-received-at" fontWeight={500}>
              {formatReceivedAt(data.receivedAt)}
            </Typography>
          )}
        </Box>
      </Box>
      {data.bodyPreview && (
        <Typography variant="caption" color="subtle">
          {truncatePreview(data.bodyPreview)}
        </Typography>
      )}
    </Box>
  );
};

export default EmailHeaderPreview;
